export default __webpack_public_path__ + "static/media/personality_ENTj.4a3cd953.png";